import type { FC, ReactNode } from 'react';

import { checkIdentityLogin, useRequireAuth } from '@/modules/auth';

interface ProtectedProps {
  children: ReactNode;
}

export const Protected: FC<ProtectedProps> = ({ children }) => {
  const auth = useRequireAuth();
  const { isIdentityLogin } = checkIdentityLogin();
  if (isIdentityLogin && (auth.isLoading || !auth.isAuthenticated)) {
    return null;
  }
  return children;
};
